import type { EventAPI } from './Types';

import type { DisablerEvent } from '@cobliteam/common-types';

export const eventAPIToDisablerEvent = (eventApi: EventAPI): DisablerEvent => ({
  deviceId: eventApi.device_id,
  lastAction: eventApi.last_action,
  lastKnownDeviceState: eventApi.last_known_device_state,
  status: eventApi.status,
});

export const eventsAPIToDisablerEvent = (eventsApi: EventAPI[]): DisablerEvent[] => eventsApi.map(eventAPIToDisablerEvent);
